<template>
  <b-card>
    <b-card-header>
      Items List
    </b-card-header>
    <b-card-body>
      <div class="table-responsive mb-0">
        <b-table
            :key="items.key"
            :items="items.data"
            :fields="fields"
            responsive="sm"
            :filter="filter"
            :current-page="current_page"
        >
          <template v-slot:cell(items_associated)="row">
            {{row.item.gravy_items_count}}
            <i class="fa fa-list-alt" @click="showItemsList"></i>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button @click="setEdit(row.item)" variant="primary">
              <i class="fa fa-pen"></i>
            </b-button>
            <b-button @click="deleteData(row.item)" variant="danger" class="ml-1">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination :key="items.key" v-model="current_page" :total-rows="items.total" :per-page="items.per_page"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from "axios";
import {GravyPath} from "@/path";

export default {
  props : ['selectedGravy'],
  name: "items_list",
  data(){
    return {
      current_page : 1,
      items : [],
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      search : '',
      fields : ['title']
    }
  },
  watch : {
    current_page (){
      this.getGravyItems();
    },
    search(){
      this.getGravyItems();
    }
  },
  mounted() {
    this.getGravyItems();
  },
  methods : {
    async getGravyItems(){
      try {
        let res = await axios.get(this.baseUrl + GravyPath.GET_ITEMS_OF_GRAVY,{
          params : {
            page : this.current_page,
            search : this.search,
            gravy_id : this.selectedGravy.id
          }
        });
        if(res.data.status){
          this.items = res.data.data;
        }
      }catch (e){
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>